import { getOwaWorkload } from 'owa-workloads';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { GeneralOptions } from 'owa-options-general';
import { MailOptions } from 'owa-options-mail';
import { CalendarOptions } from 'owa-options-calendar';

export default function getDefaultCategory(): string {
    switch (getOwaWorkload()) {
        case OwaWorkload.Mail:
        case OwaWorkload.MailMini:
            return MailOptions.key;
        case OwaWorkload.Calendar:
            return CalendarOptions.key;
        default:
            return GeneralOptions.key;
    }
}
